import DatasourceInspector from './DatasourceInspector'

export default DatasourceInspector
